import React from 'react'

import { useTranslation } from 'react-i18next'

import BPMBasicPage from '../../../components/BPMTable/PagesCreator/BPMBasicPage'
import { AvailableInvoiceTableCreator } from '../../../tableDefinitions/Invoice/AvailableInvoice/AvailableInvoiceTableCreator'

const AvailableInvoice = (props) => {
    const { t } = useTranslation('inventoryManagement')
    document.title = `${t('Available Invoices')} - BubbleBPM`

    return (
        <BPMBasicPage
            tableName={'Available Invoices'}
            tableCreatorCreatorId={AvailableInvoiceTableCreator.getId()}
            tableCreatorParams={null}
            path={props.match.url}
        />
    )
}

export default AvailableInvoice
